// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vesta-channel-list {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 320px;
  background: #d8f2ec;
}
.vesta-channel-list .str-chat__loading-channels {
  background: #d8f2ec;
}
.vesta-channel-list .filter-buttons {
  display: flex;
  padding: 20px;
}
.vesta-channel-list .filter-buttons .btn {
  white-space: nowrap;
  flex: 1;
}
.vesta-channel-list .filter-search {
  display: flex;
  margin: 20px;
  margin-top: 0px;
}
.vesta-channel-list .filter-search .form-group {
  flex: 1;
}
.vesta-channel-list .filter-search i {
  align-self: center;
  color: #3f8bf4;
  cursor: pointer;
  font-size: 24px;
  padding-left: 10px;
}
.vesta.str-chat {
  width: 100%;
  overflow: scroll;
}
.vesta.str-chat .emoji-mart-anchors {
  padding: 6px 6px;
}
.vesta.str-chat .emoji-mart-preview {
  height: 48px;
}
.vesta.str-chat .emoji-mart-preview .emoji-mart-title-label {
  font-size: 20px;
}
.vesta.str-chat .str-chat__avatar-fallback {
  background-color: #11544c;
}
.vesta.str-chat .str-chat__channel-list-messenger__header {
  display: none;
}
.vesta.str-chat .str-chat__container {
  height: calc(100vh - 55px);
  padding: 20px;
}
.vesta.str-chat .str-chat__container .message-header-container {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
}
.vesta.str-chat .str-chat__container .message-header {
  display: flex;
  padding: 15px 30px 15px 40px;
  border-radius: 10px 10px 0px 0px;
  justify-content: space-between;
  z-index: 1;
}
.vesta.str-chat .str-chat__container .message-header .info {
  display: flex;
  flex-direction: column;
}
.vesta.str-chat .str-chat__container .message-header .info .patient-caregiver {
  display: flex;
  align-items: baseline;
}
.vesta.str-chat .str-chat__container .message-header .info p,
.vesta.str-chat .str-chat__container .message-header .info a {
  margin-right: 10px;
  margin-bottom: 0px;
}
.vesta.str-chat .str-chat__container .str-chat__main-panel {
  background-color: #ffffff;
}
.vesta.str-chat .str-chat__container .str-chat__main-panel .str-chat__list {
  padding: 0px 40px;
}
.vesta.str-chat .str-chat__container .str-chat__main-panel .str-chat__input-emojiselect,
.vesta.str-chat .str-chat__container .str-chat__main-panel .str-chat__message-input .rfu-file-upload-button {
  display: unset;
  align-items: unset;
}
.vesta.str-chat .str-chat__channel-list-messenger {
  justify-content: center;
  background: #d8f2ec;
}
.vesta.str-chat .str-chat__channel-list-messenger__main {
  padding: 0px 20px;
  background-color: #d8f2ec;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview {
  width: 265px;
  padding: 10px;
  box-shadow: 0 2px 4px -4px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview p {
  white-space: nowrap;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview .str-chat__channel-preview-messenger--right {
  width: 148px;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview .str-chat__channel-preview-unread-badge {
  background: red;
  color: white;
  height: 15px;
  width: 15px;
  font-size: 10px;
  right: 5px;
  top: 2px;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview .str-chat__channel-preview--dot {
  display: none;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview button:focus {
  background: transparent;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .str-chat__channel-preview-end-first-row {
  color: black;
  font-weight: bold;
  width: 119px;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview.vesta-preview--active {
  background: #ffffff;
  border-radius: 9px;
  box-shadow: 0 0 3px rgba(102, 175, 233, 0.6);
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview.vesta-preview--active .str-chat__channel-preview-messenger--last-message p {
  color: #444444;
}
.vesta.str-chat .str-chat__channel-list-messenger__main .vesta-preview.vesta-preview--active .str-chat__channel-preview.str-chat__channel-preview--active {
  background: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chats/Chat/main.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAJA;EAQI,mBAAA;AADJ;AAPA;EAYI,aAAA;EACA,aAAA;AAFJ;AAXA;EAgBM,mBAAA;EACA,OAAA;AAFN;AAfA;EAsBI,aAAA;EACA,YAAA;EACA,eAAA;AAJJ;AApBA;EA2BM,OAAA;AAJN;AAvBA;EA+BM,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AALN;AAUA;EACE,WAAA;EACA,gBAAA;AARF;AAMA;EAKI,gBAAA;AARJ;AAGA;EASI,YAAA;AATJ;AAAA;EAYM,eAAA;AATN;AAHA;EAiBI,yBAAA;AAXJ;AANA;EAqBI,aAAA;AAZJ;AATA;EAyBI,0BAAA;EACA,aAAA;AAbJ;AAbA;EA6BM,2CAAA;AAbN;AAhBA;EAiCM,aAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,UAAA;AAdN;AAvBA;EAwCQ,aAAA;EACA,sBAAA;AAdR;AA3BA;EA4CU,aAAA;EACA,qBAAA;AAdV;AA/BA;;EAkDU,kBAAA;EACA,kBAAA;AAfV;AApCA;EAyDM,yBAAA;AAlBN;AAvCA;EA4DQ,iBAAA;AAlBR;AA1CA;;EAiEQ,cAAA;EACA,kBAAA;AAnBR;AA/CA;EAwEI,uBAAA;EACA,mBAAA;AAtBJ;AAnDA;EA6EI,iBAAA;EACA,yBAAA;AAvBJ;AAvDA;EAiFM,YAAA;EACA,aAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAvBN;AA/DA;EAyFQ,mBAAA;AAvBR;AAlEA;EA6FQ,YAAA;AAxBR;AArEA;EAiGQ,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;AAzBR;AA9EA;EA2GQ,aAAA;AA1BR;AAjFA;EAgHM,uBAAA;AA5BN;AApFA;EAoHM,YAAA;EACA,iBAAA;EACA,YAAA;AA7BN;AAzFA;EA0HM,mBAAA;EACA,kBAAA;EACA,4CAAA;AA9BN;AA9FA;EA+HQ,cAAA;AA9BR;AAjGA;EAmIQ,mBAAA;AA/BR","sourcesContent":["@import (reference) '~styleguide/src/styles/variables.less';\n\n.vesta-channel-list {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  min-width: 320px;\n  background: @lightMint;\n\n  .str-chat__loading-channels {\n    background: @lightMint;\n  }\n\n  .filter-buttons {\n    display: flex;\n    padding: 20px;\n\n    .btn {\n      white-space: nowrap;\n      flex: 1;\n    }\n  }\n\n  .filter-search {\n    display: flex;\n    margin: 20px;\n    margin-top: 0px;\n\n    .form-group {\n      flex: 1;\n    }\n\n    i {\n      align-self: center;\n      color: @btnBlue;\n      cursor: pointer;\n      font-size: @font-size-h1;\n      padding-left: 10px;\n    }\n  }\n}\n\n.vesta.str-chat {\n  width: 100%;\n  overflow: scroll;\n\n  .emoji-mart-anchors {\n    padding: 6px 6px;\n  }\n\n  .emoji-mart-preview {\n    height: 48px;\n\n    .emoji-mart-title-label {\n      font-size: 20px;\n    }\n  }\n\n  .str-chat__avatar-fallback {\n    background-color: #11544c;\n  }\n\n  .str-chat__channel-list-messenger__header {\n    display: none;\n  }\n\n  .str-chat__container {\n    height: calc(100vh - 55px);\n    padding: 20px;\n\n    .message-header-container {\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);\n    }\n\n    .message-header {\n      display: flex;\n      padding: 15px 30px 15px 40px;\n      border-radius: 10px 10px 0px 0px;\n      justify-content: space-between;\n      z-index: 1;\n\n      .info {\n        display: flex;\n        flex-direction: column;\n\n        .patient-caregiver {\n          display: flex;\n          align-items: baseline;\n        }\n\n        p,\n        a {\n          margin-right: 10px;\n          margin-bottom: 0px;\n        }\n      }\n    }\n\n    .str-chat__main-panel {\n      background-color: @white;\n\n      .str-chat__list {\n        padding: 0px 40px;\n      }\n\n      .str-chat__input-emojiselect,\n      .str-chat__message-input .rfu-file-upload-button {\n        display: unset;\n        align-items: unset;\n      }\n    }\n  }\n\n  .str-chat__channel-list-messenger {\n    justify-content: center;\n    background: @lightMint;\n  }\n\n  .str-chat__channel-list-messenger__main {\n    padding: 0px 20px;\n    background-color: @lightMint;\n\n    .vesta-preview {\n      width: 265px;\n      padding: 10px;\n      box-shadow: 0 2px 4px -4px rgba(0, 0, 0, 0.4);\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      p {\n        white-space: nowrap;\n      }\n\n      .str-chat__channel-preview-messenger--right {\n        width: 148px;\n      }\n\n      .str-chat__channel-preview-unread-badge {\n        background: red;\n        color: white;\n        height: 15px;\n        width: 15px;\n        font-size: 10px;\n        right: 5px;\n        top: 2px;\n      }\n\n      .str-chat__channel-preview--dot {\n        display: none;\n      }\n    }\n\n    .vesta-preview button:focus {\n      background: transparent;\n    }\n\n    .str-chat__channel-preview-end-first-row {\n      color: black;\n      font-weight: bold;\n      width: 119px;\n    }\n\n    .vesta-preview.vesta-preview--active {\n      background: @white;\n      border-radius: 9px;\n      box-shadow: @text-focus-shadow;\n\n      .str-chat__channel-preview-messenger--last-message p {\n        color: #444444;\n      }\n\n      .str-chat__channel-preview.str-chat__channel-preview--active {\n        background: inherit;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
